import { useEffect, useState } from "react";

// Highlights the contents link whose section is in the reading band (the
// preview's `-20% 0px -65% 0px` scroll spy). State changes only inside the
// observer callback, never synchronously in the effect.
export function useScrollSpy(ids: string[]) {
  const initialState = { activeId: "" };
  const [state, setState] = useState(initialState);
  const idList = ids.join(",");

  useEffect(() => {
    function observeSections() {
      if (!("IntersectionObserver" in window)) return undefined;
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.find((entry) => entry.isIntersecting);
          if (visible) {
            setState((state) => ({ ...state, activeId: visible.target.id }));
          }
        },
        { rootMargin: "-20% 0px -65% 0px" },
      );
      idList.split(",").forEach((id) => {
        const node = document.getElementById(id);
        if (node) observer.observe(node);
      });
      return () => observer.disconnect();
    }
    return observeSections();
  }, [idList]);

  return state.activeId;
}
